import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../App.module.css';
import Description from 'components/odds/description/Description';
import UtilsList from 'components/layout/utils-list/UtilsList';
import { UtilsTypes } from 'constants/utilsTypes';
import {
    FORMAT_DECIMAL_ODDS_PATH,
    FORMAT_ODDS_PATH,
    GET_AMERICAN_ODDS_PATH,
    GET_FRACTIONAL_ODDS_PATH,
    getOddsUtilPath,
} from 'components/odds/constants/OddsUtilConstants';

const skipRoot = true;
const oddsUtilsList = [
    {
        label: UtilsTypes.FORMAT_DECIMAL_ODDS,
        path: getOddsUtilPath(FORMAT_DECIMAL_ODDS_PATH, skipRoot),
    },
    {
        label: UtilsTypes.FORMAT_ODDS,
        path: getOddsUtilPath(FORMAT_ODDS_PATH, skipRoot),
    },
    {
        label: UtilsTypes.GET_AMERICAN_ODDS,
        path: getOddsUtilPath(GET_AMERICAN_ODDS_PATH, skipRoot),
    },
    {
        label: UtilsTypes.GET_FRACTIONAL_ODDS,
        path: getOddsUtilPath(GET_FRACTIONAL_ODDS_PATH, skipRoot),
    },
];

const OddsHelpers = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>Odds helpers</div>
                <div className={classes.Main}>
                    <Description type={UtilsTypes.ODDS_UTILS} />
                    <Divider />
                    <UtilsList props={oddsUtilsList} />
                </div>
            </div>
        </div>
    );
};

export default OddsHelpers;
